module.exports = __webpack_public_path__ + "static/media/chart_down.76414875.png";